import { faCopy } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//COMPONENTS
import Label from "../../../../../../../Components/Label";
import ButtonCustom from "../../../../../../../Components/ButtonCustom";
import { Box } from "../../../../../../../Components/CustomUi/box";
import { CopiableRow } from "../../../../../../../Components/CustomUi/copiableRow";
import { ItemRequest } from "../../../../../../../services/logs";
import { copyJson } from "./meta";

//PROPS
interface Props {
    request_selected: ItemRequest;
}

export const ResponseRequest: React.FC<Props> = ({ request_selected }) => {

    const { httpCode, content } = request_selected?.descricao?.response ?? {};

    return (
        <Box padding={15}>
            <Label style={{fontWeight: 700, color: 'var(--text-color-light)', fontSize:13}} >Resposta da requisição</Label>

            <div style={{display:'flex',flexDirection:'column'}}>
                <CopiableRow 
                    atribute="httpCode"
                    value={String(httpCode)}
                />
                <CopiableRow 
                    atribute="content"
                    value={JSON.stringify(content)}
                    isLast
                />
            </div>

            <ButtonCustom 
                onClick={()=>{copyJson(request_selected)}}
                type='secondary'
                style={{alignSelf:'flex-start'}}
                icon={<FontAwesomeIcon icon={faCopy} />}
            >
                Copiar JSON
            </ButtonCustom>
            
        </Box>
    )
}